import React from "react";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import ValidatorComponent from "components/forms/validations/component";
import { DatePickerContainer } from "./theme";

/**
 * Componente che implementa un datepicker.
 * Necessario componente separato per gestire lo stato del datepicker.
 * Il valore infatti rimarrà nello stato del componente finché l'utente non sceglie una data corretta.
 * In quel momento verrà richiamta la props onChange che restituitirà il valore corretto finale
 */
class DatePiker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getDate(props.value),
    };
  }

  getDate = (value) => {
    return value ? new Date(value) : null;
  };

  componentDidUpdate(precProps) {
    const { value } = this.props;
    if (value !== precProps.value) {
      this.setState({
        value: value ? new Date(value) : null,
      });
    }
  }

  render() {
    const { onChange, ...other } = this.props;
    return (
      <DatePicker
        {...other}
        format={this.props.format}
        value={this.state.value}
        onChange={(v) => {
          const sV = v !== null ? v.toString() : "";
          // Cambia stato corrente
          this.setState({ value: v });
          if (sV.toString() !== "Invalid Date") {
            const dt = moment(new Date(sV));
            onChange(dt.format("YYYY-MM-DD"));
          }
        }}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
      />
    );
  }
}

export default class DatePickerField extends ValidatorComponent {
  getValidations = () => {
    let val = this.props.validators ? this.props.validators : [];
    return [...val, "isValidDate"];
  };

  getHelperText = (isValid, helperText) => {
    if (isValid) return helperText;
    if (this.state.isValid) return this.state.errorMessage;
    else return this.getErrorMessage();
  };

  render() {
    /* eslint-disable no-unused-vars */
    const {
      validatorListener,
      errorMessages,
      fullWidth,
      value,
      onChange,
      invalidDateMessage,
      maxDateMessage,
      minDateMessage,
      helperText,
      formId,
      styleFormControl,
      ...other
    } = this.props;
    const isValid = this.state.isValid && this.state.dateValid;
    return (
      <DatePickerContainer
        fullWidth={fullWidth}
        styleFormControl={styleFormControl}
      >
        <div>
          <DatePiker
            {...other}
            fullWidth={fullWidth}
            error={!isValid}
            invalidDateMessage={
              invalidDateMessage
                ? invalidDateMessage
                : "La data inserita non è valida"
            }
            maxDateMessage={
              maxDateMessage
                ? maxDateMessage
                : "La data non dovrebbe essere superiore alla data massima"
            }
            minDateMessage={
              minDateMessage
                ? minDateMessage
                : "La data non dovrebbe essere inferiore alla data minima"
            }
            value={value}
            onChange={onChange}
            onError={(e) => {
              const isValid = e === "";

              if (
                isValid !== this.state.dateValid ||
                (isValid && !this.state.isValid && value !== "")
              ) {
                this.setState({
                  dateValid: isValid,
                  errorMessage: e,
                });
                if (isValid) {
                  this.makeValid();
                }
              }
            }}
          />
          <p
            className={
              "MuiFormHelperText-root MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-w1x4zq-MuiFormHelperText-root"
            }
          >
            {this.getHelperText(isValid, helperText)}
          </p>
        </div>
      </DatePickerContainer>
    );
  }
}
